import createReducer from '../createReducer';
import {
  FETCH_NEARBY_REGION,
  FETCH_NEARBY_REGION_SUCCESS,
  FETCH_NEARBY_REGION_FAILURE,
 } from '../../actions/cms/nearbyRegion';

const initialState = {
  nearbyRegion: {},
};

const handlers = {};

handlers[FETCH_NEARBY_REGION] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_NEARBY_REGION_SUCCESS] = (state, { nearbyRegion }) => ({
  ...state,
  loading: false,
  nearbyRegion,
});

handlers[FETCH_NEARBY_REGION_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/cms/nearbyRegion.js